export const DO_LOGIN = 'DO_LOGIN';
export const DO_LOGOUT = 'DO_LOGOUT';
export const LOAD_TELAPERFISPORTAL = 'LOAD_TELAPERFISPORTAL';
export const LOAD_PERFISPORTAL = 'LOAD_PERFISPORTAL';
export const LOAD_MENU = 'LOAD_MENU';